import { render, staticRenderFns } from "./User_Manage.vue?vue&type=template&id=c38d755a&"
import script from "./User_Manage.vue?vue&type=script&lang=js&"
export * from "./User_Manage.vue?vue&type=script&lang=js&"
import style0 from "./User_Manage.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports